module.exports = __webpack_public_path__ + "static/media/1POLICY17.482e8cb3.jpg";